import React, {Component} from "react"
import PropTypes from "prop-types"

import Form from "@irati/ui/src/Form"
import {Input, ValidationButton} from "@irati/ui/src/FormItem"
import Validation from "@irati/utils/validation"
import id from "@irati/utils/id"
import History from "@irati/utils/history"
import {forgotPassword} from "@irati/auth/services/password"
import {FormattedMessage, InjectIntl, injectIntl} from "@irati/utils/lang"
import authentication from "@irati/auth"
import {Body, H3} from "@irati/ui/src/Typography"
import Link from "@irati/ui/src/Link"
import Flex from "@irati/ui/src/Flex"
import withBranding, {WithBranding} from "@irati/brand/withBranding"
import {Branding} from "@irati/types"
import Loading from "@irati/ui/src/Loading"

import LoginBlock from "../../components/LoginBlock"
import LoginBackground from "../../components/LoginBackground"

interface Props extends InjectIntl, WithBranding {
  branding: Branding
}

interface State {
  email: string
  load: Promise<void> | null
}

class ForgotPassword extends Component<Props, State> {
  static contextTypes = {
    appPath: PropTypes.string.isRequired
  }

  state = {
    email: "",
    load: null
  }

  emailValidation = () => {
    const schema = Validation.string("platform.defaultLogin.fields.emailValidation.enterEmail")
    return schema.email("platform.defaultLogin.fields.emailValidation.notValid")
  }

  handleSubmit = () => {
    const {email} = this.state

    if (email) {
      const load = forgotPassword(email, authentication.unAuthedBusiness()).then(() => {
        History.push(
          {
            pathname: "/welcome/login/check-email",
            email
          },
          this.context
        )
      })
      this.setState({load})
    }
  }

  handleBack = () => History.push("/welcome/login")

  render() {
    const {email, load} = this.state
    const {branding, formatMessage} = this.props
    /**  containers should force to init the idNamespace */
    const idNamespace = id("forgot-password", this.props, {force: true})
    const helpLinks = [
      <Link href={formatMessage({id: "platform.checkEmail.help.forgotPasswordUrl"})} target="_blank">
        <FormattedMessage id="platform.checkEmail.help.helpLink" />
      </Link>
    ]

    return (
      <LoginBackground>
        <LoginBlock id={idNamespace} helpLinks={helpLinks} showBrandingInHeader onBack={this.handleBack}>
          <H3 marginBottom={1} id={id("title", idNamespace)} textAlign="center">
            <FormattedMessage id="platform.forgotPassword.resetPassword.title" />
          </H3>
          <Body small marginBottom={2} textAlign="center" maxWidth="100%">
            <FormattedMessage id="platform.forgotPassword.resetPassword.subTitle" />
          </Body>
          <Form id={id("form", idNamespace)}>
            <Input
              id={id("field-email", idNamespace)}
              label={formatMessage({id: "platform.forgotPassword.email.label"})}
              name="email"
              type="email"
              value={email}
              placeholder={formatMessage({id: "platform.forgotPassword.email.placeholder"})}
              onChange={(value: string) => this.setState({email: value, load: null})}
              validation={this.emailValidation()}
            />
            <ValidationButton primary mobileFull full id={id("btn-submit", idNamespace)} load={load} onClick={this.handleSubmit}>
              <FormattedMessage id="platform.forgotPassword.button.send" />
            </ValidationButton>
            <Flex justifyContent="flex-end" width="100%" padding={[0, 2]} marginTop>
              <Loading id={idNamespace} load={load} useLoader={false} />
            </Flex>
          </Form>
        </LoginBlock>
      </LoginBackground>
    )
  }
}

export default injectIntl(withBranding(ForgotPassword))
